module.exports = __webpack_public_path__ + "img/logo-fifalotto-white4.60c085f6.png";